module.exports = __webpack_public_path__ + "static/media/student21.ae02e935.png";